// DashboardRecipeRow.js
import React, { useState, useEffect, useCallback } from 'react';
import { Grid, message, Row, Col, Spin, Card, Divider, Typography } from 'antd';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import RecipeCard from '../RecipeCard';
import NewRecipePopover from '../recipe/NewRecipeButton';

const { useBreakpoint } = Grid;



function getDomain(url) {
  if (!url) return null;
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return null;
  }
}

const DashboardRecipeRow = () => {
  const [data, setData] = useState([]);        // [{ recipeCategory, recipeLists: [...] }]
  const [loading, setLoading] = useState(false);
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [messageApi] = message.useMessage();

const { Title } = Typography;

  const fetchRecipes = useCallback(async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/recipes?numberOfcategories=1`;
      const res = await axios.get(url, { withCredentials: true });
      setData(res.data || []);
    } catch {
      messageApi.error('Failed to fetch recipes');
      setData([]);
    }
    setLoading(false);
  }, [messageApi]);

  useEffect(() => {
    fetchRecipes();
  }, [fetchRecipes]);

  const gutter = screens.xs ? 8 : 16;

  const firstCategory = Array.isArray(data) && data.length > 0 ? data[0] : null;
  const recipeLists = firstCategory?.recipeLists || [];

  

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 24 }}>
        <Spin />
      </div>
    );
  }

  if (!recipeLists.length) return null;

  const isMobile = screens.xs;

  return (
    <div>
      <div
        style={{
          display: 'flex',
          marginBottom: 12,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Title level={4} style={{ margin: 0 }}>
          Recipes For You
        </Title>
        <NewRecipePopover />
      </div>

      <Row
        gutter={gutter}
        wrap={isMobile}                           // stack on mobile
        style={isMobile ? {} : { overflowX: 'auto' }} // horizontal scroll only desktop
      >
        {recipeLists.map((record) => {
          const { recipe, keyPhoto, ingredients, caloriesPerPortion } = record;
          const domain = getDomain(recipe.sourceURL);

          return (
            <Col
              key={recipe.id}
              xs={24}                             // full width on mobile
              sm={12}
              md={8}
              lg={6}
              style={{ marginBottom: 16 }}
              {...(!isMobile && { flex: '0 0 260px' })} // fixed width for desktop row
            >
              <RecipeCard
                recipe={recipe}
                record={record}
                keyPhoto={keyPhoto}
                ingredients={ingredients}
                caloriesPerPortion={caloriesPerPortion}
                domain={domain}
                navigate={navigate}
                // no menu prop on dashboard
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );

};

export default DashboardRecipeRow;
